import { areResourcesLoading } from "helpers/data-statuses"
import { get, mapValues } from "lodash"
import { createSelector } from "reselect"

const EMPTY_ARRAY = []

const getAllResources = state => get(state, "global.data", EMPTY_ARRAY)

export const getAllResourcesStatuses = createSelector(
  [getAllResources],
  (resources) => mapValues(resources, "status"),
)

export const getIsHasUnexpandedCompositesLoading = createSelector(
  [getAllResourcesStatuses],
  (statuses) => areResourcesLoading("hasUnexpandedComposites", statuses),
)
